
import './App.css';
import axios from "axios"
import SideBar from './components/SideBar/SideBar';
import { Outlet } from 'react-router-dom';
import React, { useEffect } from 'react';
import useLocalStorage from './hooks/useLocalStorage';

function App() {
  const [AppTheme,setAppTheme] = useLocalStorage("theme",undefined)
  useEffect(() => {
    if (AppTheme == undefined) setAppTheme("Theme1")
    const container = document.querySelector("#root") as HTMLElement
    container.className = `root ${AppTheme}`
  }, [AppTheme])
  return (
    <div className='App-Container' id='App'>
      <SideBar />
      <Outlet />
    </div>
  );
}

export default App;
